// 叙简平台工具
import util from "@/util/util";
import {ElMessage} from "element-plus";

export default {
    xujianBaseUrl: process.env.VUE_APP_XJ_URL,
    userInfo: null,
    // 验证用户账号，是否已登录叙简账号
    checkUser() {
        return new Promise((resolve, reject) => {
            if (this.userInfo) {
                if (this.userInfo.accountLoginType === "XuJian") { // 这是叙简账号登录，并且是通过叙简系统登录
                    resolve();
                } else {
                    reject();
                }
            } else {
                util.getUserInfo().then(userInfo => {
                    this.userInfo = userInfo;
                    if (this.userInfo.accountLoginType === "XuJian") { // 这是叙简账号登录，并且是通过叙简系统登录
                        resolve();
                    } else {
                        reject();
                    }
                })
            }

        })
    },
    // 获取叙简的访问地址
    getXuJianBaseUrl() {
        if (window.location.host.startsWith("localhost") || window.location.host.startsWith("192.168")) {
            // 本地内网
            return this.xujianBaseUrl.replaceAll("183.223.88.3", "192.168.10.184");
        }
        return this.xujianBaseUrl;
    },
    // 跳转到叙简平台,跳转到GIS页面
    toXuJian() {
        this.jump2XuJianByUrl(`/scooper-gis-map/#/home/gis?token=`);
    },
    // 跳转到叙简监控管理页面
    toXuJianMonitor() {
        this.jump2XuJianByUrl(`/scooper-poc-web/#/main/minitor/terminal?token=`)
    },
    // 根据url，跳转到叙简平台页面
    jump2XuJianByUrl(url) {
        this.checkUser().then(() => {
            window.open(this.getXuJianBaseUrl() + `${url}${this.userInfo.token}`);
        }).catch(() => {
            ElMessage.error("您的帐号尚未绑定融合通讯平台帐号，请联系管理员");
        })
    }
}